import { Injectable } from '@angular/core'

@Injectable()

export class IvasService {


  tabla = 'rest_ivas';
  data = [];

  constructor(){

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || [];

  }



  get(){

    return this.data;

  }



  getByID(id){

    let aux = null;

    for(let item of this.data){

      if(item.id == id){

        aux = item;
      }
    }

    return aux;
  }



  set(data){

    this.data = data;
    localStorage.setItem(this.tabla, JSON.stringify(data));

    return this.data;

  }



  delete(){

    this.data = null;
    localStorage.removeItem(this.tabla);

    return this.data;
  }

}



// WEBPACK FOOTER //
// ./src/services/IvasService.ts